





















































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch, Prop, Mixins } from 'vue-property-decorator';
import { vxm } from './../store.vuex';
import { UserProfile } from '../models/userdata/profile';
import Datepicker from 'vuejs-datepicker';
import {en, de, es, fr} from 'vuejs-datepicker/dist/locale';
import { JobHistoryInfo } from '../models/jobs/jobhistoryinfo';
import JobHistoryPager from './JobHistoryPager.vue';
import { UserJobHistory } from '../models/jobs/userjobhistory';
import { UserCompanyInfo } from '../models/jobs/usercompanyinfo';
import { UserJobHistoryListRequest } from '../models/jobs/userjobhistorylistrequest';
import Paginator from '@/components/Commons/Paginator.vue';
import { ModelListSelect } from 'vue-search-select';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import { UserCompany } from '../models/jobs/usercompany';
import Avatar from 'vue-avatar';
import CandidatePortalLogo from './CandidatePortalLogo.vue';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import GuidedSignupUtilities from '@/components/GuidedSignup/utilities';
import JobHistoryCustomFields from '@/components/GuidedSignup/JobHistoryCustomFields.vue';
import moment from 'moment';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import ConfirmationModal from '@/components/Commons/ConfirmationModal.vue';
import ProfilePlaceholder from '@/components/Commons/ProfilePlaceholder.vue';
import AddEntity from '@/components/Commons/AddEntity.vue';

Vue.component('vue-phone-number-input', VuePhoneNumberInput);
import { countries } from './Commons/phone-code-countries';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});
declare var window: any;


@Component({
  name: 'NewJobHistoryDetails',
  components: {
    Datepicker,
    ModelListSelect,
    JobHistoryPager,
    Avatar,
    CandidatePortalLogo,
    VueGoogleAutocomplete,
    JobHistoryCustomFields,
    ProfilePlaceholder,
    AddEntity,
    Paginator,
  },
})
export default class NewJobHistoryDetails extends Mixins(
  GuidedSignupUtilities,
) {
  public $wlToastr: any;
  private errorString: string = '';
  private isEditing: boolean = false;
  private jHistory: UserJobHistory = new UserJobHistory();
  private userCompanyListing: UserCompany[] = [];
  private userCompany: UserCompany = new UserCompany();
  private enableSave: boolean = false;
  private showAddNewjob: boolean = true;
  private addMode: boolean = false;
  private showAddJobHistory: boolean = false;
  private isTypeable: boolean = false;
  private countryCode: string = '';
  private noExample: boolean = true;
  public mode: string = 'read';
  private candidatePhone: string = '';
  private countryExt: string = '';
  private phoneNumberValid = false;
  private roleHelpText = '';
  private pageSize = 3;
  $moment: any;
  @Prop({ default: () => new Vue(), type: Vue }) bus;

  @Prop () isRequiredStep;
  @Prop () minimumEntries;
  
  get getLanguage() {
    const lang = vxm.users.getUserLang || 'en';
    return {en, de, es, fr}[lang];
  }

  get companyName() {
    return vxm.configs.getGlobalConfigValue('COMPANY_NAME');
  }

  public errors = {
    startDTTMText: '',
    jobRole: '',
    companyName: '',
    candidatePhone: '',
    endDTTMText: '',
    jobLocation: '',
  };
  get sectionSubHeader(){
    if( this.minimumEntries>1 && this.userPermissionConfig('edit')){
      return `You need to add at least ${
          this.minimumEntries
        } work experience`
    }
   return ''
 }
 get isConfigEnabled(){
      if(window.WorkLLama.isConfigJSONEnabled==='true'){
        return true
      }
      return false
      }

  @Watch('jobHistory')
  onJobHistoryChange(newVal, oldVal) {
    const disable = this.minimumEntries >= 0 ? (this.isRequiredStep
    ? newVal.length < this.minimumEntries : this.isRequiredStep) : newVal.length === 0;
    this.$emit('disable-next-button', disable);
  }
  
  get canShowSupervisorInfo(){
     return !vxm.jobs.BrandingInfo.HIDE_SUPERVISOR_INFO_WORK_EXPERIENCE;
  }

  get canShowFieldInWorkExperience() {
    return (fieldName) => {
      return vxm.configs.canShowFieldInWorkExperience(fieldName)
    }
  }

  get userPermissionConfig() {
    return (permission) => {
      return vxm.configs.getWorkExperiencePermissionConfig(permission)
    }
  }

  get disabledEndDate() {
    if (this.jHistory.currentJob) {
      return {
        to: moment()
          .subtract(1, 'days')
          .endOf('day')
          .toDate(),
      };
    }
    return {
      from: moment()
        .subtract(1, 'days')
        .endOf('day')
        .toDate(),
    };
  }

  get disabledStartDate() {
    return {
      from: moment()
        .subtract(1, 'days')
        .endOf('day')
        .toDate(),
    };
  }

  setFacilityAddress(address, address1) {
    this.jHistory.companyInfo.facilityAddress = address.locality;
  }
  onChangeFacilityAddress({ newVal }) {
    this.jHistory.companyInfo.facilityAddress = newVal;
  }

  updateRoleHelpText(val) {
    this.roleHelpText = val;
  }

  onChangeCurrentJob() {
    this.errors = { ...this.errors, endDTTMText: '' };
    if (
      !this.jHistory.currentJob &&
      new Date(this.jHistory.endDTTMText).getTime() > new Date().getTime()
    ) {
      this.jHistory.endDTTMText = '';
    }
  }

  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }

  get jobHistoryReasons(): any {
    var reasons = vxm.jobs.UserJobHistoryListResponse.reasons;
    reasons.sort(function(reason1, reason2) {
      var r1 = reason1.name.toUpperCase();
      var r2 = reason2.name.toUpperCase();
      return r1 < r2 ? -1 : r2 > r1 ? 1 : 0;
    });
    return vxm.jobs.UserJobHistoryListResponse.reasons;
  }

  get jobHistoryPager() {
    return vxm.jobs.JobHistoryPager;
  }

  get jobHistory(): JobHistoryInfo[] {
    if (!vxm.jobs.UserJobHistoryListResponse.jobHistories) {
      return [];
    }
    const list = vxm.jobs.UserJobHistoryListResponse.jobHistories;
    if (!Array.isArray(list)) {
      return [];
    }
    return list.map((jobH) => {
      const startDTTM = this.$moment(new Date(jobH['startDTTM'])).format(
        'YYYY-MM-DD',
      );
      const endDTTM =
        jobH['endDTTM'] &&
        this.$moment(new Date(jobH['endDTTM'])).format('YYYY-MM-DD');
      return { ...jobH, startDTTM, endDTTM };
    });
  }

  mounted() {
    this.bus.$on('on-next-step', this.onNextStep);
    this.showAddJobHistory = !!this.userPermissionConfig('add');
    this.getNewJobHistory();
    this.setCountryCode();
    vxm.users.fetchWizardSteps();
  }

  confirmDeleteJobHistory() {
    this.$modal.show(
      ConfirmationModal,
      {
        header: this.$t('NewJobHistoryDetails_DeleteExperience'),
        body: this.$t('NewJobHistoryDetails_ConfirmDeleteExperience'),
        okText: this.$t('global.ok.text'),
        cancelText: this.$t('global.cancel-text'),
        onOk: () => {
          this.deleteJobHistory();
        },
      },
      {
        height: 'auto',
        clickToClose: false,
      },
    );
  }

  getCustomData(jobHistoryInfo) {
    //const list = vxm.jobs.UserJobHistoryListResponse.jobHistoryList;
    const jobHistoryCustomData_: any = vxm.jobs.UserJobHistoryListResponseCopy; // an array of meta data
    const jobHistoryCustomMetaDataValues = jobHistoryInfo.jobHistoryCustomData;
    return jobHistoryCustomData_.jobHistoryMetaData.map((customMetaData) => {
      return {
        name: customMetaData.name,
        label: customMetaData.label,
        value: jobHistoryCustomMetaDataValues[customMetaData.name], //
        id: customMetaData.id,
        type: customMetaData.type,
      };
    });
  }

  setCountryCode() {
    let userParams = vxm.users.UserParams;
    this.countryCode = vxm.jobs.getCompanyCountryCode;
    if (userParams.populateSignupPage) {
      this.candidatePhone = userParams.phone.substring(
        userParams.phone.indexOf(' ') + 1,
      );
      let dialCode = userParams.phone.substring(
        1,
        userParams.phone.indexOf(' '),
      );
      for (var i = 0; i < countries.length; i++) {
        if (countries[i].dialCode === dialCode) {
          this.countryCode = countries[i].iso2;
        }
      }
    }
  }

  get supportedCountries() {
    return vxm.utility.supportedCountries;
  }

  get defaultCountry() {
    let areaCode = '';
    if (
      this.candidatePhone !== null &&
      this.candidatePhone.replace('(', '').trim().length > 3
    ) {
      areaCode = this.candidatePhone
        .replace('(', '')
        .trim()
        .substring(0, 3);
    }
    if (this.countryExt !== null && this.countryExt !== '') {
      for (var i = 0; i < countries.length; i++) {
        if (this.countryExt === '1') {
          if (
            countries[i].dialCode === this.countryExt &&
            areaCode !== '' &&
            areaCode !== null &&
            JSON.stringify(countries[i].areaCodes).includes(areaCode)
          ) {
            console.log('default country' + countries[i].iso2);
            return countries[i].iso2;
          } else if (
            countries[i].dialCode === this.countryExt &&
            areaCode !== '' &&
            areaCode !== null &&
            !JSON.stringify(countries[i].areaCodes).includes(areaCode)
          ) {
            return 'US';
          } else if (
            countries[i].dialCode === this.countryExt &&
            (areaCode === '' || areaCode === null)
          ) {
            console.log('default country' + countries[i].iso2);
            return countries[i].iso2;
          }
        } else {
          if (countries[i].dialCode === this.countryExt) {
            console.log('default country' + countries[i].iso2);
            return countries[i].iso2;
          }
        }
      }
    } else {
      console.log('default country' + vxm.utility.defaultCountry);
      return vxm.utility.defaultCountry;
    }
  }

  get jobHistoryReasonForLeavingObj(): any {
    let data = vxm.jobs.jobHistoryReasonForLeavingObj;
    return data;
  }

  format(value, event) {
    console.log('Its called');
    return moment(value).format(this.getCompanyDateFormat.toUpperCase());
  }

  beforeDestroy() {
    this.bus.$off('on-next-step');
  }

  onNextStep() {
    this.$emit('go-to-next');
  }

  get getCompanyDateFormat() {
    return vxm.jobs.getCompanyDateFormat;
  }

  getCompanyImage(companyCode) {
    const COMPANY_LOGO_URL = vxm.configs.getGlobalConfigValue(
      'CONTEXT_URL_COMPANY_LOGO_URL_ALIAS',
    );
    const LOGO_FILE_SEPERATOR = '/';
    const LOGO_FILE = vxm.utility.companyLogoFile;
    const CompanyLogoUrl =
      COMPANY_LOGO_URL +
      LOGO_FILE_SEPERATOR +
      companyCode +
      LOGO_FILE_SEPERATOR +
      LOGO_FILE;
    return CompanyLogoUrl;
  }

  public transferLoad(history: JobHistoryInfo) {
    this.jHistory.jobHistoryId = history.userCompanyJobHistoryId;
    this.jHistory.jobRole = history.jobRole;
    this.countryExt = history.supervisorPhoneNum
      ? history.supervisorPhoneNum.substring(
          1,
          history.supervisorPhoneNum.indexOf(' '),
        )
      : '';
    this.candidatePhone = history.supervisorPhoneNum
      ? history.supervisorPhoneNum.substring(
          history.supervisorPhoneNum.indexOf(' '),
        )
      : history.supervisorPhoneNum;
    this.jHistory.startDTTM = history.startDTTM;
    this.jHistory.startDTTMText = this.$moment(history.startDTTM)._d;
      this.jHistory.endDTTM = history.endDTTM ? history.endDTTM : '';
      this.jHistory.endDTTMText = history.endDTTM ? this.$moment(history.endDTTM)._d : '';
    this.jHistory.currentJob = history.currentJob;
    this.jHistory.companyInfo = {...history.companyInfo}

    const uc = new UserCompany();
    uc.name = history.companyInfo.companyName;
    uc.code = history.companyInfo.companyCode;
    this.userCompanyListing = []; //added by santhosh as part of new theme
    this.userCompanyListing.push(uc);
    this.userCompany.name = history.companyInfo.companyName;
    this.userCompany.code = history.companyInfo.companyCode;

    this.jHistory.fullTimeJob = history.fullTimeJob;
    this.jHistory.supervisorName = history.superVisorName;
    this.jHistory.supervisorPhoneNum = history.supervisorPhoneNum;
    this.jHistory.contactSupervisor = history.contactSupervisor;
    if (history.reasonId && vxm.jobs.UserJobHistoryListResponse.reasons) {
      this.jHistory.reasonId = vxm.jobs.UserJobHistoryListResponse.reasons.filter(
        (reason) => reason.reasonId === history.reasonId,
      )[0].reasonId;
    }

    console.log('full time job:' + history.fullTimeJob);
    this.jHistory.function = 'U';
    this.setCustomFieldsData(history);
    this.addMode = false;
    this.showAddNewjob = false;
    this.mode = 'edit';
  }

  setCustomFieldsData(history: JobHistoryInfo) {
    if (history.jobHistoryCustomData) {
      Object.keys(history.jobHistoryCustomData).forEach((key) => {
        this.jHistory.jobHistoryCustomData[key] =
          history.jobHistoryCustomData[key];
      });
    }
    this.addCustomFieldsError();
  }

  public transformDate(dttm: number): string {
    const locale = vxm.users.getUserLang || 'en';
    return moment(dttm).locale(locale).format(this.getCompanyDateFormat.toUpperCase());
  }

  public toggleEdit() {
    this.isEditing = !this.isEditing;
  }

  public toggleShowAddNewjob() {
    this.showAddNewjob = !this.showAddNewjob;
  }

  public newJobHistory() {
    console.log('adding new job history');
    this.showAddNewjob = false;
    this.jHistory = new UserJobHistory();
    this.jHistory.function = 'A';
    this.isEditing = !this.isEditing;
    this.userCompanyListing = [];
    this.userCompany = new UserCompany();
    this.addMode = true;
    this.mode = 'add';
    this.candidatePhone = '';
    this.countryExt = '';
    this.addCustomFieldsError();
    this.initializeCustomFields();
    this.checkForSaveButton();
  }

  initializeCustomFields() {
    let customData = vxm.jobs.UserJobHistoryListResponseCopy.jobHistoryMetaData;
    if (customData && customData.length > 0) {
      customData.forEach(
        (customField) =>
          (this.jHistory.jobHistoryCustomData[customField.name] = ''),
      );
    }
  }

  addCustomFieldsError() {
    let customData = vxm.jobs.UserJobHistoryListResponse.jobHistoryMetaData;
    if (customData && customData.length > 0) {
      customData.forEach((customField) => {
        if (customField.required) {
          this.errors[customField.name] = '';
        }
      });
    }
    this.errors = { ...this.errors };
  }

  public cancelEdit() {
    this.jHistory = new UserJobHistory();
    this.jHistory.function = 'A';
    this.toggleEdit();
    this.checkForSaveButton();
  }

  public checkForSaveButton() {
    if (
      this.jHistory.jobRole &&
      this.jHistory.startDTTMText &&
      this.userCompany.name
    ) {
      this.enableSave = true;
    } else {
      this.enableSave = false;
    }
  }
  public updateJobHistory1() {
    this.jHistory.companyInfo.companyName = this.userCompany.name;
    if (this.validateJobHistoryForm()) {
      return;
    }
    let userJobHistory = new UserJobHistory();
    userJobHistory.jobHistoryId = this.jHistory.jobHistoryId;
    userJobHistory.fullTimeJob = this.jHistory.fullTimeJob;
    userJobHistory.currentJob = this.jHistory.currentJob;
    userJobHistory.jobHistoryCustomData = this.jHistory.jobHistoryCustomData;

    userJobHistory.reasonId = this.jHistory.reasonId;
    userJobHistory.supervisorName = this.jHistory.supervisorName;
    userJobHistory.supervisorPhoneNum = this.jHistory.supervisorPhoneNum;
    if (!this.candidatePhone) {
      userJobHistory.supervisorPhoneNum = this.candidatePhone;
      this.jHistory.contactSupervisor = false;
    }
    userJobHistory.contactSupervisor = this.jHistory.contactSupervisor;
    userJobHistory.jobRole = this.jHistory.jobRole;
    this.jHistory.startDTTMText = this.jHistory.startDTTMText
      .toString()
      .replace(/ -/g, ' ');
    this.jHistory.startDTTMText = this.$moment(this.jHistory.startDTTMText)._d;
    this.jHistory.startDTTM = new Date(this.jHistory.startDTTMText).getTime();
    userJobHistory.startDTTM = this.jHistory.startDTTM;
    userJobHistory.startDTTMText = this.jHistory.startDTTMText;
    if (this.jHistory.endDTTMText) {
      this.jHistory.endDTTMText = this.jHistory.endDTTMText
        .toString()
        .replace(/ -/g, ' ');
      this.jHistory.endDTTMText = this.$moment(this.jHistory.endDTTMText)._d;
      this.jHistory.endDTTM = new Date(this.jHistory.endDTTMText).getTime();
      if (this.jHistory.startDTTM >= this.jHistory.endDTTM) {
        this.$wlToastr(
          'error',
          this.$t('NewJobHistoryDetails_WorkExperienceEndDateGreaterThanStartDateError'),
          this.$t('NewJobHistoryDetails_WorkExperience'),
        );
        return;
      }
      if (this.jHistory.startDTTM > new Date().getTime()) {
        this.$wlToastr(
          'error',
          this.$t('NewJobHistoryDetails_WorkExperienceFutereStartDateError'),
          this.$t('NewJobHistoryDetails_WorkExperience'),
        );
        return;
      }
      userJobHistory.endDTTM = this.jHistory.endDTTM;
      userJobHistory.endDTTMText = this.jHistory.endDTTMText;
    } else {
      if (this.jHistory.startDTTM > new Date().getTime()) {
        this.$wlToastr(
          'error',
          this.$t('NewJobHistoryDetails_WorkExperienceFutereStartDateError'),
          this.$t('NewJobHistoryDetails_WorkExperience'),
        );
        return;
      }
    }

    let userCompanyInfo = new UserCompanyInfo();
    userCompanyInfo.companyCode = this.userCompany.code;
    userCompanyInfo.companyName = this.userCompany.name; //this.jHistory.companyInfo.companyName;
    userCompanyInfo.facilityAddress = this.jHistory.companyInfo.facilityAddress;
    userCompanyInfo.companyLogo = this.jHistory.companyInfo.companyLogo;
    userCompanyInfo.logoLastModified = this.jHistory.companyInfo.logoLastModified;
    userCompanyInfo.companyId = this.jHistory.companyInfo.companyId;
    userJobHistory.companyInfo = userCompanyInfo;
    var result = new Date(userJobHistory.startDTTM);
    userJobHistory.startDTTM = result.getTime();
    var result1 = new Date(userJobHistory.endDTTM);
    userJobHistory.endDTTM = result1.getTime();

    vxm.jobs.updateJobHistory(userJobHistory).then((resp) => {
      if (vxm.jobs.UserJobHistoryUpdateResponse.meta['success']) {
    if (this.mode === 'read') {
      this.$wlToastr(
        'success',
        this.$t('NewJobHistoryDetails_WorkExperienceCreationSuccessful'),
            this.$t('NewJobHistoryDetails_WorkExperience'),
      );
    } else {
      this.$wlToastr(
        'success',
        this.$t('NewJobHistoryDetails_WorkExperienceUpdateSuccessful'),
            this.$t('NewJobHistoryDetails_WorkExperience'),
      );
          vxm.users.Rudderstack.trackEvent("Work Experience Updated", {
            companyName: userCompanyInfo.companyName,
            companyAdderss: userCompanyInfo.facilityAddress,
            startDate: userJobHistory.startDTTM,
            endDate :userJobHistory.endDTTM
          })
    }

    vxm.users.getProfileStrength();
    this.addMode = false;
    this.mode = 'read';
    this.toggleShowAddNewjob();
    this.getNewJobHistory();
  } else {
    this.addMode = false;
    this.mode = 'read';
      this.$wlToastr(
        'error',
        vxm.jobs.UserJobHistoryUpdateResponse['error']
            ? vxm.jobs.UserJobHistoryUpdateResponse['error']['detailedMessage']
            : '',
          this.$t('NewJobHistoryDetails_WorkExperience'),
      );
    }
    }).catch((error) => {
      // Check if the error is due to a 400 status code and handle it
      if (error.response && error.response.status === 400 && error.response.data.meta.error.detailedMessage) {
        const errorMessage = error.response.data.meta.error.detailedMessage;
        this.$wlToastr(
          'error',
          errorMessage,
          this.$t('NewJobHistoryDetails_WorkExperience')
        );
      } 
    });
  }

  validateJobHistoryForm() {
    this.errors = {
      startDTTMText: '',
      jobRole: '',
      companyName: '',
      candidatePhone: '',
      endDTTMText: '',
      jobLocation: '',
    };
    this.errors.startDTTMText = this.jHistory.startDTTMText
      ? ''
      : this.$t('this.field.required').toString();
    (this.errors.jobRole = this.jHistory.jobRole && this.jHistory.jobRole.trim()
      ? ''
      : this.$t('this.field.required').toString()),
      (this.errors.companyName = this.jHistory.companyInfo.companyName && this.jHistory.companyInfo.companyName.trim()
        ? ''
        : this.$t('this.field.required').toString());
    this.errors.candidatePhone =
      this.candidatePhone && !this.phoneNumberValid
        ? this.$t('invalid-ph-number-text').toString()
        : '';
    this.errors.endDTTMText =
      this.jHistory.currentJob || this.jHistory.endDTTMText
        ? ''
        : this.$t('this.field.required').toString();
    // custom field Error check

    const customData = this.jHistory.jobHistoryCustomData;
    const response = vxm.jobs.UserJobHistoryListResponse;
    response.jobHistoryMetaData.forEach((field) => {
      if (field.required && !customData[field.name]) {
        this.errors[field.name] = this.$t('this.field.required');
      } else {
        this.errors[field.name] = '';
      }
    });

    const isInvalid = Object.keys(this.errors).some((entity) => {
      return this.errors[entity];
    });

    if (isInvalid) {
      this.errors = { ...this.errors };
    }

    return isInvalid;
  }

  updateCandidatePhone(event) {
    console.log(
      'Number is :  ',
      '+' + event.countryCallingCode + ' ' + event.nationalNumber,
    );
    let phone = '+' + event.countryCallingCode + ' ' + event.nationalNumber;
    this.jHistory.supervisorPhoneNum = phone;

    this.phoneNumberValid = event.isValid;
  }

  public printSearchText(searchText: string) {
    this.setOutsideCompany(searchText);
    const vm = this;
    if (searchText.trim().length >= 3) {
      const respPromise: any = vxm.jobs.getCompanyListing(searchText);
      Promise.all([respPromise]).then((values) => {
        if (
          vxm.jobs.UserCompanyListing !== null &&
          vxm.jobs.UserCompanyListing.length > 0
        ) {
          console.log('database list:' + vxm.jobs.UserCompanyListing);
          this.userCompanyListing = vxm.jobs.UserCompanyListing;
        }
      });
    }
  }

  public setOutsideCompany(searchText: string) {
    if (!searchText) return;
    console.log(searchText);
    let uCompany = new UserCompany();
    uCompany.name = searchText;
    uCompany.code = vxm.users.getCompanyCode;
    this.userCompany = uCompany;
    if (this.userCompanyListing.length > 0) {
      this.userCompanyListing[0].name = searchText;
      this.userCompanyListing[0].code = vxm.users.getCompanyCode;
      this.userCompany.name = searchText;
      this.userCompany.code = vxm.users.getCompanyCode;
    } else {
      this.userCompanyListing.push(uCompany);
    }
  }

  public removeOptions() {
    this.userCompanyListing = [];
  }

  public deleteJobHistory() {
    if (
      !this.jHistory.startDTTMText ||
      !this.jHistory.jobRole ||
      !this.jHistory.companyInfo
    ) {
      this.$wlToastr(
        'error',
        this.$t('NewJobHistoryDetails_DeleteExperienceError'),
        this.$t('NewJobHistoryDetails_WorkExperience'),
      );
    } else {
      let userJobHistory = new UserJobHistory();
      //userJobHistory = this.jHistory;
      userJobHistory.function = 'D';
      userJobHistory.jobHistoryId = this.jHistory.jobHistoryId;
      userJobHistory.startDTTM = this.jHistory.startDTTM;
      userJobHistory.startDTTMText = this.jHistory.startDTTMText;
      userJobHistory.currentJob = this.jHistory.currentJob;
      userJobHistory.jobRole = this.jHistory.jobRole;
      userJobHistory.companyInfo = this.jHistory.companyInfo;
      userJobHistory.fullTimeJob = this.jHistory.fullTimeJob;
      if (!userJobHistory.currentJob) {
        userJobHistory.endDTTM = this.jHistory.endDTTM;
        userJobHistory.endDTTMText = this.jHistory.endDTTMText;
      }
      //userJobHistory.endDTTM = 32503593600000;
      // this.jHistory.function = 'D';

      vxm.jobs.deleteJobHistory(userJobHistory).then((resp) => {
        if (vxm.jobs.UserJobHistoryUpdateResponse.meta['success']) {
          this.$wlToastr(
            'success',
            this.$t('NewJobHistoryDetails_WorkExperienceDeleteSuccessful'),
            this.$t('NewJobHistoryDetails_WorkExperience'),
          );
          vxm.users.getProfileStrength();
          this.addMode = false;
          this.mode = 'read';
          this.toggleShowAddNewjob();
          this.getNewJobHistory();
        } else {
          this.addMode = false;
          this.mode = 'read';
          this.$wlToastr(
            'error',
            vxm.jobs.UserJobHistoryUpdateResponse['error']
              ? vxm.jobs.UserJobHistoryUpdateResponse['error'][
                  'detailedMessage'
                ]
              : '',
            this.$t('NewJobHistoryDetails_WorkExperience'),
          );
        }
      });
    }
  }

  public getJobHistory() {
    const token = vxm.users.getToken;
    const jhr = new UserJobHistoryListRequest();
    jhr.resultSize = 10;
    jhr.resultPage = 1;
    vxm.jobs.getJobHistory(jhr);
  }

  public getNewJobHistory(pageNum = 1) {
    vxm.jobs.getNewJobHistory({ pageNum, pageSize: this.pageSize });
  }

  public onFetchList(pageNum) {
    vxm.jobs.getNewJobHistory({ pageNum: pageNum, pageSize: this.pageSize });
  }

  public cancelAddNewJob() {
    this.showAddNewjob = true;
    this.mode = 'read';
    if (this.addMode) this.addMode = false;
  }

  getFristCapitalletter(value: string): string {
    if (!value) return '';
    value = value.toString();
    return value
      .trim()
      .charAt(0)
      .toUpperCase();
  }

  public isCurrentCompany(value: string): boolean {
    if (value == 'KFORCEconnect') {
      console.log('returning true');
      return true;
    } else {
      console.log('returning false');
      return false;
    }
  }

  getAddressDataEdit(addressData, placeResultData, id) {
    if (addressData.locality && addressData.administrative_area_level_1) {
      this.jHistory.companyInfo.facilityAddress =
        addressData.locality + ', ' + addressData.administrative_area_level_1;
      return;
    }
    this.jHistory.companyInfo.facilityAddress =
      addressData.locality || addressData.administrative_area_level_1 || '';
  }

  onNoResultsEdit() {
    this.$wlToastr('error', this.$t('please-enter-valid-location-error-text'));
  }

  isAlphabet(e) {
    let char = String.fromCharCode(e.keyCode); // Get the character
    if (/^[A-Za-z/ /.]+$/.test(char)) return true;
    // Match with regex
    e.preventDefault(); // If not match, don't add to input text
    return false;
  }

  public deleteJobHistoryNew(history: JobHistoryInfo) {
    this.$modal.show(
      ConfirmationModal,
      {
        header: this.$t('NewJobHistoryDetails_DeleteExperience'),
        body: this.$t('NewJobHistoryDetails_ConfirmDeleteExperience'),
        okText: this.$t('global.ok.text'),
        cancelText: this.$t('global.cancel-text'),
        onOk: () => {
          this.deleteCurrentJobHistory(history);
        },
      },
      {
        height: 'auto',
        clickToClose: false,
      },
    );
  }

  public deleteCurrentJobHistory(history: JobHistoryInfo) {
    if (!history.startDTTM || !history.companyInfo) {
      this.$wlToastr(
        'error',
        this.$t('NewJobHistoryDetails_DeleteExperienceError'),
        this.$t('NewJobHistoryDetails_WorkExperience'),
      );
    } else {
      let userJobHistory = new UserJobHistory();
      userJobHistory.jobHistoryId = history.userCompanyJobHistoryId;
      vxm.jobs.deleteJobHistory(userJobHistory).then((resp) => {
        if (vxm.jobs.UserJobHistoryUpdateResponse.meta['success']) {
          this.$wlToastr(
            'success',
            this.$t('NewJobHistoryDetails_WorkExperienceDeleteSuccessful'),
            this.$t('NewJobHistoryDetails_WorkExperience'),
          );
          vxm.users.getProfileStrength();
          this.getNewJobHistory();
        } else {
          this.$wlToastr(
            'error',
            vxm.jobs.UserJobHistoryUpdateResponse['error']
              ? vxm.jobs.UserJobHistoryUpdateResponse['error'][
                  'detailedMessage'
                ]
              : '',
            this.$t('NewJobHistoryDetails_WorkExperience'),
          );
        }
      });
    }
  }

  isFirstChild(val: string) {
    return val == '0';
  }
}
